export const snakeCaseToCamelCase = (str: string) =>
  str.replace(/_([a-z0-9])/g, (_, g) => g.toUpperCase());

export const camelCaseToSnakeCase = (str: string) =>
  str.replace(/([A-Z0-9])/g, '_$1').toLowerCase();
